import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ImageDropzone from '../ImageDropzone/ImageDropzone';
export function NPCModalForm({ isOpen, onClose, onSubmit, isLoading, mode, npc, title, submitIdleLabel, submitBusyLabel }) {
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [nameError, setNameError] = useState('');
    // Reset (create) or populate (edit) the form state every time the modal opens
    useEffect(() => {
        if (!isOpen)
            return;
        if (mode === 'edit') {
            if (!npc)
                return;
            setName(npc.name);
            setImage(npc.image);
        }
        else {
            setName('');
            setImage(null);
        }
        setNameError('');
    }, [isOpen, npc, mode]);
    const handleSubmit = (e) => {
        e.preventDefault();
        // Validation
        if (!name.trim()) {
            setNameError('Name is required');
            return;
        }
        onSubmit({
            name: name.trim(),
            image
        });
    };
    const handleClose = () => {
        setName('');
        setImage(null);
        setNameError('');
        onClose();
    };
    const handleNameChange = (e) => {
        const value = e.target.value;
        setName(value);
        if (nameError && value.trim()) {
            setNameError('');
        }
    };
    if (!isOpen || (mode === 'edit' && !npc))
        return null;
    return (_jsx("div", { className: "modal-overlay", onClick: handleClose, children: _jsxs("div", { className: "modal-content", onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "modal-header", children: [_jsx("h2", { children: title }), _jsx("button", { className: "close-button", onClick: handleClose, disabled: isLoading, children: "\u00D7" })] }), _jsxs("form", { onSubmit: handleSubmit, className: "modal-form", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "npcName", children: "Name" }), _jsx("input", { id: "npcName", type: "text", value: name, onChange: handleNameChange, placeholder: "Enter NPC name", disabled: isLoading, className: nameError ? 'error' : '' }), nameError && _jsx("span", { className: "error-text", children: nameError })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Image" }), _jsx(ImageDropzone, { currentImageUrl: image, onUploadSuccess: setImage })] }), _jsxs("div", { className: "modal-actions", children: [_jsx("button", { type: "button", onClick: handleClose, disabled: isLoading, children: "Cancel" }), _jsx("button", { type: "submit", disabled: isLoading || !name.trim(), children: isLoading ? submitBusyLabel : submitIdleLabel })] })] })] }) }));
}
